import type { Word } from '../types';
import { t } from '../i18n/translations';
import type { Language } from '../i18n/translations';

interface CategoryGridProps {
  categoriesMap: Record<string, Word[]>;
  selectedCategories: Set<string>;
  deselectedWords: Set<string>;
  collapsed: boolean;
  verbMode: boolean;
  onToggleCategory: (cat: string) => void;
  onOpenModal: (cat: string) => void;
  language?: Language;
}

export default function CategoryGrid({
  categoriesMap,
  selectedCategories,
  deselectedWords,
  collapsed,
  verbMode,
  onToggleCategory,
  onOpenModal,
  language = 'en',
}: CategoryGridProps) {
  const sortedCats = Object.keys(categoriesMap).sort();

  const getActiveCount = (cat: string): number => {
    const words = categoriesMap[cat] || [];
    return words.filter((w) => !deselectedWords.has(`${cat}::${w.pl}`)).length;
  };

  return (
    <div
      className={`categories-grid${collapsed ? ' collapsed' : ''}${verbMode ? ' hidden' : ''}`}
      id="categories"
    >
      {sortedCats.map((cat) => {
        const count = categoriesMap[cat].length;
        const activeCount = getActiveCount(cat);
        const checked = selectedCategories.has(cat);
        return (
          <div
            key={cat}
            className={`category-chip${checked ? ' selected' : ''}`}
            data-cat={cat}
            onClick={(e) => {
              const target = e.target as HTMLElement;
              if (target.dataset.action === 'edit') return;
              onToggleCategory(cat);
            }}
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={() => onToggleCategory(cat)}
              onClick={(e) => e.stopPropagation()}
            />
            <span className="cat-label">{cat}</span>
            <span className="cat-count">
              {activeCount !== count ? `${activeCount}/` : ''}
              {count}
            </span>
            <span
              className="cat-edit"
              data-action="edit"
              title={t(language, 'category.editWords')}
              onClick={(e) => {
                e.stopPropagation();
                onOpenModal(cat);
              }}
            >
              ⚙
            </span>
          </div>
        );
      })}
    </div>
  );
}
